import ApplicationController from "./application_controller";


export default class extends ApplicationController {
  static targets = ["table", "toolbar", "check", "filtercontainer", "filteritem"];
  static values = {
    copyfields: Array,
  };

  connect() {
    this.sortOrder = [];
    this.setupSorting();

    this.setupSelection();
    console.log("DatatableController connected");
  }

  toggleFilters() {
    this.filtercontainerTarget.classList.toggle("d-none");
  }

  setupSorting() {
    let headCells = this.tableTarget.querySelectorAll("th");

    for (var colIndex = 0; colIndex < headCells.length; colIndex++) {
      headCells[colIndex].dataset.action =
        headCells[colIndex].dataset.action + " click->datatable#sort";
    }
  }

  setupSelection() {
    let headerrow = this.tableTarget.querySelector("thead tr");
    headerrow.innerHTML =
      '<td class="text-center"><button class="btn btn-sm btn-secondary p-0 m-1" data-action="click->datatable#toggleSelect"><i class="bi bi-check"></i></button></td>' +
      headerrow.innerHTML;

    let trs = this.tableTarget.querySelectorAll("tbody tr");
    for (let i = 0; i < trs.length; i++) {
      let tr = trs[i];
      let check = tr.classList.contains("inactive") ? "" : 'checked="checked"';

      tr.innerHTML =
        '<td class=" text-center"><input type="checkbox" ' +
        check +
        'data-datatable-target="check"></td>' +
        tr.innerHTML;
    }
  }
  selectRow(e) {
    if (e.target.dataset["datatable-target"] == "check") {
      return true;
    }
    let tr = event.target.closest("tr");
    let input = tr.querySelector('input[type="checkbox"]');
    input.checked = !input.checked;
  }
  toggleSelect() {
    for (let i = 0; i < this.checkTargets.length; i++) {
      if (this.checkTargets[i].offsetParent === null) {
        this.checkTargets[i].checked = false;
      } else {
        this.checkTargets[i].checked = !this.checkTargets[i].checked;
      }
    }
  }
  toggleInactive() {
    let inactive_trs = this.tableTarget.querySelectorAll("tr.inactive");

    for (let i = 0; i < inactive_trs.length; i++) {
      inactive_trs[i].classList.toggle("d-none");
      let input = inactive_trs[i].querySelector('input[type="checkbox"]');
      if (input != undefined) {
        input.checked = false;
      }
    }
  }
  sort(e) {
    let th = e.target.closest("th");
    th.dataset.sort = th.dataset.sort == "ASC" ? "DESC" : "ASC";

    let order = th.dataset.sort;
    let col = th.cellIndex;

    console.log("reached sort by col: " + col + " order:" + order);

    var tb = this.tableTarget.querySelector("tbody"), // use `<tbody>` to ignore `<thead>` and `<tfoot>` rows
      tr = Array.from(tb.querySelectorAll("tr")), // put rows into array
      i;

    var reverse = order == "DESC" ? 1 : -1;
    reverse = -(+reverse || -1);
    tr = tr.sort(function (a, b) {
      // sort rows
      console.log("in sort function: " + a.cells[col].textContent);
      return (
        reverse * // `-1 *` if want opposite order
        a.cells[col].textContent
          .trim()
          .localeCompare(b.cells[col].textContent.trim())
      );
    });
    console.log("sorting " + tb);
    for (i = 0; i < tr.length; ++i) {
      tb.appendChild(tr[i]); // append each row in order
    }
  }

  getSelectedRows = function () {
    return Array.from(
      this.tableTarget.querySelectorAll("tr:has(input[type=checkbox]:checked)"),
    );
  };

  copyList(e, fieldname = "schulemail") {
    event.stopPropagation();
    var emails = this.getSelectedRows().map(
      function (tr) {
        let datafield = tr.querySelector('[data-field="' + fieldname + '"]');
        if (datafield != undefined && datafield.dataset) {
          return datafield.dataset.value;
        }
      }.bind(fieldname),
    );

    copy(emails.join("; "));
    this.showmsg(emails.length + " Datensätze kopiert", 300);
  }

  setCheckboxInTr(tr, checkstatus) {
    var checkbox = tr.querySelector("input[type=checkbox]");
    if (checkbox) {
      checkbox.checked = checkstatus;
    }
  }

  filter(event) {
    console.log("Filter by " + event.target.value);
    this.filteritemTargets.forEach(function (item) {
      if(item.dataset.value != event.target.value){
        let tr = item.closest("tr");
        tr.classList.add("d-none");
        this.setCheckboxInTr(tr, false);
      }
    }.bind(this));
  }

}
